export const getQueryParamByName = (url, name) => {
  const [baseUrl, fragment] = url.split('#')
  // Extract the query string from the base URL
  const queryString = baseUrl.split('?')[1] || ''
  // Extract the query string from the fragment if it exists
  const fragmentQueryString = fragment ? (fragment.split('?')[1] ?? '') : '';

  // Combine query parameters from both the base URL and the fragment
  const queryParams = queryString.split('&').concat(fragmentQueryString.split('&')).filter(Boolean)

  for (let i = 0; i < queryParams.length; i++) {
    let [key, value] = queryParams[i].split('=')
    try {
      key = decodeURIComponent(key)
      value = decodeURIComponent(value)
    } catch (e) {
      console.error(`Decoding error for param: ${key} with value: ${value}`, e)
      continue // Skip this iteration if there's an error decoding
    }

    if (key === name) {
      if (value === 'undefined') {
        return null
      }
      // Check for the presence of '/' in the value and return the part before it
      const slashIndex = value.indexOf('/')
      if (slashIndex !== -1) {
        return value.substring(0, slashIndex) // Return the value up to the '/'
      }
      return value
    }
  }
  return null
}
